import React from 'react';
import { HistoriaLandingPage } from './pages/HistoriaLandingPage';
export function App() {
  return <HistoriaLandingPage data-id="element-0" />;
}